import * as React from 'react'
import { useBreakpoint } from 'gatsby-plugin-breakpoints'
import { useStaticQuery, graphql } from "gatsby"
import { DesktopFooter } from './DesktopFooter'
import { MobileFooter } from './MobileFooter'
import { CountryBase } from 'templates/fragments/country'
import { RegionBase, RegionStub } from 'templates/fragments/region'

export const Footer = () => {
    const breakpoints = useBreakpoint();
    const isDesktop = !breakpoints.md;
    const isMobile = breakpoints.md;
    const data: {
        bestDestinations: {
            bestCountries: CountryBase[],
            bestRegions: RegionStub[]
        }
    } = useStaticQuery(graphql`
    {
      bestDestinations: commonDataJson {
        bestCountries {
            ...CountryBase
        }
        bestRegions {
            ...RegionStub
        }
    }
    }
  `)
    return (<div>
        {/* {transitions((styles, showCookieConsentBar) => showCookieConsentBar &&  <animated.div style={styles}><CookieConsent onClick={()=>setShowCookieConsentBar(false)}/></animated.div>)} */ }
        {isDesktop && <DesktopFooter bestCountries={data.bestDestinations.bestCountries} bestRegions={data.bestDestinations.bestRegions}/> }
        {isMobile && <MobileFooter bestCountries={data.bestDestinations.bestCountries} bestRegions={data.bestDestinations.bestRegions}/>}
    </div>
    )
}